import { render, staticRenderFns } from "./merge-field.vue?vue&type=template&id=d0003146&scoped=true&"
import script from "./merge-field.vue?vue&type=script&lang=js&"
export * from "./merge-field.vue?vue&type=script&lang=js&"
import style0 from "./merge-field.vue?vue&type=style&index=0&id=d0003146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0003146",
  null
  
)

export default component.exports